export function HostAgreementContent() {
  return (
    <div className="prose-legal">
      <p className="text-xs text-app-muted mb-6">Last updated: June 2026 · Draft — pending legal review</p>

      <h2>The short version</h2>
      <ul>
        <li>You're an <strong>independent local host</strong>, not a Sekretly employee. You run your own thing; we connect you to travellers whose taste fits.</li>
        <li>Travellers pay through <strong>Stripe</strong>. We collect, keep our commission, and pay you the rest via Stripe Connect.</li>
        <li>You handle your own taxes, licences, and insurance.</li>
        <li>Protect travellers' data and treat people well. Keep it on-platform.</li>
        <li>Anything you contribute to the platform (recommendations, content) can be used by Sekretly, including to power our curation and AI.</li>
        <li>Either side can end this, and there are rules about doing right by travellers you've already committed to.</li>
      </ul>

      <h2>1. Relationship</h2>
      <p>You act as an independent contractor. Nothing creates an employment, agency, or partnership relationship. You control how, when, and whether you provide host services. You are responsible for your own taxes, social security, VAT, and any required licences.</p>

      <h2>2. Eligibility and onboarding</h2>
      <p>You must be at least 18 and have the legal right to provide your services. Sekretly may screen, vet, or request background checks. You must create a Stripe Connect account to receive payments.</p>

      <h2>3. Host services and standards</h2>
      <p>You provide local curation and hosting services to matched travellers. You agree to act professionally, honour commitments, respond in reasonable time, provide accurate recommendations, and not discriminate. You are responsible for the safety of experiences you provide.</p>

      <h2>4. Payments and commission</h2>
      <p>Travellers pay through Stripe. Sekretly collects the payment, deducts its commission and processing fees, and settles the balance to you via Stripe Connect. You must process all Sekretly-introduced bookings through the platform.</p>

      <h2>5. Data protection</h2>
      <p>You receive only the traveller information needed for the engagement. You will keep it confidential, not sell it, not use it for your own marketing, and delete it when the engagement ends or when requested. You will notify Sekretly promptly of any data breach affecting traveller data.</p>

      <h2>6. Content, IP, and AI</h2>
      <p>You grant Sekretly a worldwide, perpetual, royalty-free licence to use your contributed content (recommendations, place data, media) to operate, promote, and improve the Service and to train our AI systems. The Sekretly platform, brand, Alma, and curated databases are owned by Sekretly.</p>

      <h2>7. Confidentiality</h2>
      <p>You will keep confidential any non-public information you learn through Sekretly, including traveller information, commercial terms, and platform know-how.</p>

      <h2>8. Anti-circumvention</h2>
      <p>For travellers introduced through Sekretly, you will not take the relationship off-platform to avoid commission, solicit off-platform bookings, or encourage them to leave Sekretly.</p>

      <h2>9. Warranties, liability, and indemnity</h2>
      <p>You warrant that you will provide services with reasonable skill and care. You indemnify Sekretly from claims arising from your services, content, or breach of this Agreement. You are responsible for arranging your own insurance.</p>

      <h2>10. Suspension and termination</h2>
      <p>Either party may terminate with notice. Sekretly may suspend access immediately for breach or safety concerns. On termination, you will fulfil or hand over existing commitments to travellers.</p>

      <h2>11. Governing law</h2>
      <p>This Agreement is governed by the laws of Portugal.</p>

      <p className="text-xs text-app-muted mt-8 italic">Sekretly — curated by people, not feeds.</p>
    </div>
  );
}
